import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../../components/DashboardLayout';

export default function OwnerNotice() {
  const { reference } = useParams();
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setItems([]);
    setError('');
    const token = localStorage.getItem('token');
    const clinicId = localStorage.getItem('clinicId');
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/clinic/${encodeURIComponent(clinicId)}/owner-query-alerts/${encodeURIComponent(reference)}`, {
      headers: { Authorization: `Bearer ${token}` }, signal: controller.signal
    }).then(async response => {
      if (!response.ok) throw new Error(response.status === 401 || response.status === 403
        ? 'Inicia sesión con la cuenta de tu clínica y vuelve a abrir esta liga.'
        : 'No se pudo abrir el aviso. Intenta nuevamente.');
      return response.json();
    }).then(data => setItems(data.items || []))
      .catch(err => { if (err.name !== 'AbortError') setError(err.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [reference]);
  const first = items[0];
  return <DashboardLayout>
    <section className="max-w-3xl mx-auto p-6 rounded-xl bg-white text-slate-900 space-y-4">
      <h1 className="text-2xl font-semibold">{first?.flow === 'booking_conversation' ? 'Conversación de citas' : 'Aviso de redes'}</h1>
      {loading && <p>Cargando aviso…</p>}
      {error && <p role="alert">{error}</p>}
      {first && <>
        <p><strong>{first.name}</strong> · {first.channel}</p>
        {items.map(item => <article key={item.part} className="border rounded-lg p-4">
          <p className="text-sm text-slate-600">{item.who} · {item.part}/{item.parts}</p>
          <p className="whitespace-pre-wrap break-words">{item.detail_text}</p>
        </article>)}
        {first.flow === 'social_notice' && <p>Este aviso no genera una respuesta automática. Puedes responder en la red o pedir que preparemos un borrador.</p>}
        {(first.reply_url || first.original_url) ? <a className="text-blue-700 underline" href={first.reply_url || first.original_url} target="_blank" rel="noopener noreferrer">Responder en la red social</a>
          : <p className="text-sm text-slate-600">La red no proporcionó una liga al original. Aquí se muestra el mensaje recibido.</p>}
      </>}
    </section>
  </DashboardLayout>;
}
